import { FileType, FileUploadStatusEnum } from "../enums";
import { IFile } from "../interfaces";
import {
  FileModel,
  ImportFileModel,
  ImportVideoModel,
  VideoModel,
} from "../models";
import { FileLocation } from "../types";

/**
 * Абстрактный базовый класс для всех файловых моделей
 * Реализует основной интерфейс IFile и предоставляет базовую функциональность
 */
export abstract class AbstractFileModel implements IFile {
  /**ID файла */
  FileId!: number;
  /**Расположение файла */
  Location!: FileLocation;
  /**Статус файла */
  Status!: FileUploadStatusEnum;
  /**Прогресс загрузки */
  Progress?: number;
  /**Ссылка на файл */
  Url!: string;
  /**Название файла */
  Name!: string;
  /**Размер файла */
  Size!: number;
  /**Дата создания файла */
  DateCreate!: Date;
  /**Тип файла */
  abstract readonly Type: FileType;
  /**Файл является импортируемым */
  abstract readonly IsImport: boolean;

  constructor(obj?: Partial<AbstractFileModel>) {
    Object.assign(this, obj);
  }

  // ====================================
  // Type Guards (проверки типов)
  // ====================================

  /**
   * Проверяет, является ли файл обычным (не видео и не импортированным)
   * @returns {this is FileModel} - Тип-гард для FileModel
   */
  isFileModel(): this is FileModel {
    return !this.IsImport && this.Type === FileType.FILE;
  }
  /**
   * Проверяет, является ли файл видео (не импортированным)
   * @returns {this is VideoModel} - Тип-гард для VideoModel
   */
  isVideoModel(): this is VideoModel {
    return !this.IsImport && this.Type === FileType.VIDEO;
  }
  /**
   * Проверяет, является ли файл импортированным (не видео)
   * @returns {this is ImportFileModel} - Тип-гард для ImportFileModel
   */
  isImportFileModel(): this is ImportFileModel {
    return this.IsImport && this.Type === FileType.FILE;
  }
  /**
   * Проверяет, является ли файл импортированным видео
   * @returns {this is ImportVideoModel} - Тип-гард для ImportVideoModel
   */
  isImportVideoModel(): this is ImportVideoModel {
    return this.IsImport && this.Type === FileType.VIDEO;
  }
}
